<div class="spotlight">
  <app-section-container class="padding-top">
    <app-section-heading>
      <span class="text__black">In the</span>
      <span class="text__primary"> Spotlight</span>
    </app-section-heading>
    <app-section-description>
      <span class="text__black">
        {{ description }}
      </span>
    </app-section-description>
  </app-section-container>

  <div class="position-relative spotlight-carousel-wrapper">
    @if (articlesList.length) {
      <div
        class="spotlight-carousel-arrow-col gap-3 d-flex align-items-center justify-content-start justify-content-md-end"
      >
        <div class="filter-chips mb-3 pl-md-0 position-relative">
          <ul
            class="d-flex align-items-center px-2 justify-content-md-center justify-content-start overflow-x-auto"
          >
            <li
              class="d-flex align-items-center view-all text-nowrap"
              [ngClass]="{
                active: selectedCategory == spotlightCategory.viewAll,
              }"
              (click)="onSpotlightCategoryClick(spotlightCategory.viewAll)"
            >
              <img
                src="images/view-all.svg"
                height="24"
                width="25"
                alt="view-all"
              />
              <span>View All</span>
            </li>
          </ul>
        </div>

        <div>
          <button
            class="d-flex align-items-center mx-2 justify-content-center spotlight-carousel-arrow spotlight-carousel-arrow--prev"
          >
            <img
              src="images/prev-arrow.svg"
              height="14"
              width="10"
              alt="prev arrow"
            />
          </button>
          <button
            class="d-flex align-items-center mx-2 justify-content-center spotlight-carousel-arrow spotlight-carousel-arrow--next"
          >
            <img
              width="10"
              height="14"
              src="images/next-arrow.svg"
              alt="Next"
            />
          </button>
        </div>
      </div>
    }

    <div class="spotlight-bg swiper-section">
      <swiper-container id="spotlight-swiper-container" init="false">
        @if (isLoading) {
          @for (i of [1, 2, 3, 4, 5, 6, 7, 8]; track i) {
            <swiper-slide class="spotlight-carousel-slides">
              <div class="col-12">
                <div
                  class="card-container dataset-card skeleton-card overflow-hidden d-flex flex-column h-100"
                  aria-hidden="true"
                >
                  <div>
                    <div class="skeleton-image"></div>
                    <div class="dataset-card_content">
                      <div class="skeleton-text skeleton-title"></div>
                      <div class="skeleton-text skeleton-description"></div>
                    </div>
                  </div>

                  <div class="mt-auto">
                    <div class="px-3 pb-2">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center">
                          <div class="skeleton-avatar"></div>
                          <div class="skeleton-text skeleton-username"></div>
                        </div>
                        <div class="skeleton-text skeleton-readtime"></div>
                      </div>
                    </div>
                    <hr class="m-0 px-0 text-gray" />
                    <div
                      class="m-3 d-flex justify-content-between align-items-center"
                    >
                      <div class="skeleton-button"></div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          }
        } @else {
          @for (
            articleListItem of articlesList;
            track articleListItem;
            let index = $index
          ) {
            <swiper-slide class="spotlight-carousel-slides">
              <div class="col-12">
                <div
                  class="card-container dataset-card overflow-hidden d-flex flex-column h-100"
                >
                  <div>
                    <app-card-header-image [showUpdatedTime]="false">
                      <img
                        imagePlaceholder
                        fetchpriority="low"
                        width="100%"
                        [imgLazyLoad]="articleListItem?.banner_url"
                        [alt]="articleListItem?.title || 'Article Name'"
                        class="article-image object-fit-cover"
                      />
                    </app-card-header-image>
                    <div class="dataset-card_content p-2">
                      <div class="fw-500 dataset-header text-base">
                        {{ articleListItem?.title || "N.A." }}
                      </div>
                      <div
                        class="secondary-color text-xs description dataset-header"
                      >
                        {{ articleListItem?.short_description || "N.A." }}
                      </div>
                    </div>
                  </div>

                  <div class="mt-auto">
                    <div class="px-2 py-2">
                      <div class="mb-3">
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <img
                              fetchpriority="low"
                              class="rounded-circle bg-white object-fit-contain"
                              imagePlaceholder
                              imageFallBack="images/fallback-avatar.png"
                              ngProjectAs="[profileImage]"
                              width="24px"
                              height="24px"
                              [alt]="
                                articleListItem?.owner_details?.name ||
                                'Username'
                              "
                              [title]="
                                articleListItem?.owner_details?.name ||
                                'Username'
                              "
                              [imgLazyLoad]="
                                articleListItem?.owner_details?.profilepic
                              "
                            />
                            <span class="text-xs fw-400 mx-1">{{
                              articleListItem?.owner_details?.name || "Username"
                            }}</span>
                          </div>

                          <div class="text-xs fw-400 text-muted">
                            {{ articleListItem?.read_time || "NA" }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr class="m-0 px-0 text-gray" />
                    <div
                      class="m-3 d-flex justify-content-between align-items-center"
                    >
                      <a
                        role="button"
                        class="btn-tertiary-bordered btn h-auto px-3 py-2"
                        (click)="goToDetailsPage(articleListItem.id)"
                        >View Article</a
                      >
                      <div class="d-flex align-items-center gap-2">
                        @if (showVoteBtn(articleListItem?.owner_details?.id)) {
                          <app-upvote-downvote
                            [entityType]="artefactType.article"
                            [entityDetails]="articleListItem"
                            (onVoteChange)="handleVote(articleListItem?.id)"
                          ></app-upvote-downvote>
                        }
                        <img
                          (click)="handleSocialShare(articleListItem)"
                          class="btn cursor-pointer"
                          src="images/share.svg"
                          alt="share"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          }
        }
        <div class="spotlight-swiper-pagination swiper-pagination"></div>
      </swiper-container>
    </div>
  </div>
</div>
